import { render, staticRenderFns } from "./AppFormWidgetItem.vue?vue&type=template&id=50cd013b&scoped=true&"
import script from "./AppFormWidgetItem.vue?vue&type=script&lang=js&"
export * from "./AppFormWidgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd013b",
  null
  
)

export default component.exports